import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'

import PredictiveIcon from '../../svgs/predictive.svg'
import StrategyIcon from '../../svgs/strategy.svg'
import DesignIcon from '../../svgs/design.svg'
import DataIcon from '../../svgs/data-engineering.svg'
import OutreachIcon from '../../svgs/outreach.svg'
import MaasIcon from '../../svgs/measurement.svg'

const ServicesLoop = ({ services }) => {
  return (
    <ServicesLoopContainer>
        {services.map(service => {
            let iconComponent = <PredictiveIcon />;

            switch(service.node.slug) {
            case "strategy":
                iconComponent = <StrategyIcon />;
                break;
            case "design":
                iconComponent = <DesignIcon />;
                break;
            case "data-engineering":
                iconComponent = <DataIcon />;
                break;
            case "outreach":
                iconComponent = <OutreachIcon />;
                break;
            case "measurement-service":
                iconComponent = <MaasIcon />;
                break;
            default:
                break;
            }
            
            return (
            <article itemScope itemType="http://schema.org/Article">
                <Link>
                    <div>
                        <div class="service-icon">{iconComponent}</div>
                        <h3 dangerouslySetInnerHTML={{ __html: service.node.title }} itemProp="headline" />
                        <div class="service-description" dangerouslySetInnerHTML={{ __html: service.node.ServiceDescription.serviceDescriptionContent}} itemProp="description" />
                    </div>
                </Link>
            </article>
            )
        })}
    </ServicesLoopContainer>
  )
}

export default ServicesLoop

const ServicesLoopContainer = styled.section`
    max-width: 1170px;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;

    article {
        width: calc(33.33% - 15px);
        margin-top: 0;
        margin-bottom: 30px;

        .service-icon {
            height: 120px;
            margin: 0 auto;
            margin-bottom: 35px;
            display: flex;
            justify-content: center;
            align-items: center;

            svg {
                height: 100%;
                
                .pr0,
                .str1,
                .des1,
                .dae1,
                .out1,
                .mes1 {
                    transition: all .3s cubic-bezier(.77,0,.175,1);
                }
            }
        }

        a {
            display: block;
            padding: 40px 0px;
            width: 100%;
            height: 100%;
            border: 5px solid #eaeaea;
            background-color: transparent;
            transition: all .3s cubic-bezier(.77,0,.175,1);
            text-decoration: none !important;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;

            > div {
                width: 100%;
            }
        }

        h3 {
            font-family: din-condensed, sans-serif;
            font-weight: 400;
            font-style: normal;
            letter-spacing: 1px;
            font-size: 30px;
            line-height: 40px;
            color: #C44C4A;
            text-transform: uppercase;
            text-align: center;
            padding: 0 30px;
            margin-top: 0;
            margin-bottom: 30px;
            width: 100%;
        }

        ul {
            font-family: "Work Sans";
            font-size: 18px;
            font-weight: 400;
            color: #2b2520;
            padding-left: 20px;
            margin: 0 40px;
            list-style-position: outside;
            transition: all .3s cubic-bezier(.77,0,.175,1);

            li {
                margin-bottom: 0;
                line-height: 2;
            }
        }

        .service-description {
            width: 100%;
        }

        .service-button {
            font-family: "Work Sans";
            font-size: 20px;
            line-height: 50px;
            font-weight: 700;
            color: #2b2520;
            text-decoration: none;
            border: 3px solid #C44C4A;
            display: block;
            width: 250px;
            height: 50px;
            margin: 0 auto;
            margin-top: 30px;
            align-self: flex-end;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all .3s cubic-bezier(.77,0,.175,1);

            svg {
                color: #C44C4A;
                margin-left: 10px;
                transition: all .3s cubic-bezier(.77,0,.175,1);
            }

            &:hover {
                svg {
                    transform: translateX(10px);
                }
            }
        }

        &:hover {
            a {
                background-color: #2b2520;
                border-color: #2b2520;
            }

            ul {
                color: #fff;
            }

            .service-button {
                background-color: #C44C4A;
                color: #fff;

                svg {
                    color: #fff;
                }
            }

            svg {
                .pr0,
                .str1,
                .des1,
                .dae1,
                .out1,
                .mes1 {
                    fill: #fff;
                }
            }
        }
    }
    
    @media(max-width:1000px) {
        max-width: 700px;
        article {
            width: calc(50% - 15px)
        }
    }

    @media(max-width: 767px) {
        max-width: 500px;
        margin: 50px auto;
        padding: 0px;

        article {
            width: 100%;

            a {
                padding: 20px 0;
                padding-top: 40px; 
            }
            
            ul {
                margin: 0 20px;
            }
        }
    }
`
